import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Input, Select } from 'antd';

const InputGroup = Input.Group;
const Search = Input.Search;
const Option = Select.Option;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const appType = this.modulesState.isOpen;
        return (
            <div className={css.appSearch}>
                <div className={css.searchGroup}>
                    <InputGroup compact={true}>
                        <span onClick={() => { ModulesAction.changeIsOpen('1');}} className={appType === '1' ? css.typeActive : css.type}>公开dd应用</span>
                        <span onClick={() => { ModulesAction.changeIsOpen('0'); }} className={appType === '0' ? css.typeActive : css.type}>私有应用</span>
                        <span onClick={() => { ModulesAction.changeIsOpen('myApp'); }} className={appType === 'myApp' ? css.typeActive : css.type}>我的应用</span>
                        <Select 
                            defaultValue={this.modulesState.appCategory} 
                            style={{ width: 100, marginLeft: 20}}
                            onChange={ModulesAction.blindAppCategory}
                        >
                            <Option value={0} >全部分类</Option>
                            {
                                this.modulesState.appCategoryList.map((item) => {
                                    return <Option key={item.categoryId} value={item.categoryId} >{item.categoryName}</Option>;
                                })
                            }
                        </Select>
                        <Search
                            placeholder="输入关键字快速查找"
                            value={this.modulesState.searchInfo}
                            onChange={ModulesAction.blindSearchData}
                            onSearch={ModulesAction.onSearch}
                            style={{ width: 250 }}
                        />
                    </InputGroup>
                    </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/UI.AppSearch.tsx